import React from 'react'
import { routes } from '@sketch/modules-common'
import { Redirect } from 'react-router'

import { WorkspaceMinimalFragment } from '@sketch/gql-types'

interface CollectionsViewProps {
  workspace: WorkspaceMinimalFragment
  projectId: string
  collectionId: string
}

const CollectionsView = ({ workspace, projectId }: CollectionsViewProps) => {
  return (
    <Redirect
      to={routes.WORKSPACE_PROJECT.create({
        workspaceId: workspace.identifier,
        projectId,
      })}
    />
  )
}

export default CollectionsView
